import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { WalletLinkCard } from './ui/wallet_link.js';

export { WalletLinkCard } from './ui/wallet_link.js';

/**
 * Entrada de catálogo do `wallet_link` (slot chat). Policy igual à do `flight_seat_link`:
 * o botão só navega (`open-wallet`, client-side, sem turno nem challenge) — vale depois de
 * qualquer resposta (`freezeWhenSupersededBy: []`); cada emissão ancora na própria mensagem
 * (`reconcileById: false`).
 */
export const walletLinkEntry: GenUiEntry<Extract<ChatUi, { kind: 'wallet_link' }>> = {
  kind: 'wallet_link',
  slot: 'chat',
  policy: { reconcileById: false, freezeWhenSupersededBy: [] },
  render: ({ ui, readOnly, dispatch }) => (
    <WalletLinkCard screen={ui.screen} readOnly={readOnly} dispatch={dispatch} />
  ),
};
